var canUseDOM = function () {
    return Boolean(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
};
var supportsVoiceOver = function () {
    return /Mac OS X/.test(canUseDOM() ? navigator.userAgent : '');
};
export default supportsVoiceOver;
//# sourceMappingURL=supportsVoiceover.js.map